import styled from 'styled-components';

import { CheckOutlined } from '@ant-design/icons';

import { BodilColor } from '~src/branding';
import { boxShadows } from '~src/branding/boxShadow';

const { greyscale, ui, base } = BodilColor;

export const Container = styled.div<{ selected?: boolean; backgroundColor: string; backgroundColorSelected: string }>(
  ({ selected, backgroundColor, backgroundColorSelected }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    justifyContent: 'space-between',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: selected ? backgroundColorSelected : backgroundColor,
    border: `1px solid ${greyscale[30]}`,
    borderRadius: 20,
    padding: '12px 8px',
    minHeight: 450,
    width: 300,
  })
);

export const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const Body = styled.div({
  padding: '0 8px',
  minHeight: '200px',
});

export const InfoRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '0 32px',
});

export const ImageWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  cursor: 'pointer',
});

export const InfoContainer = styled.div<{ height: number }>(({ height }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'center',
  gap: '32px',
  height,
}));

export const CompactCardWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 120,
});

export const CompactCardContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ...boxShadows.large,
  background: base.white,
  margin: '8px',
  borderRadius: '10px',
  cursor: 'pointer',
  position: 'relative',
  height: 110,
  width: 110,
});

export const CheckCircle = styled.div<{ selected?: boolean; color?: string }>(({ selected, color }) => ({
  position: 'absolute',
  top: '10%',
  right: '10%',
  background: selected ? color ?? ui.action.default : greyscale['40'],
  border: `solid ${greyscale['30']} 3px`,
  opacity: 0.5,
  height: '25px',
  width: '25px',
  borderRadius: '25px',
}));

export const CheckmarkOutlined = styled(CheckOutlined)({
  padding: '8px',
  fontSize: 16,
  width: 'fit-content',
});
